import { createContext } from 'react';
import { PaymentsEligibilityStatus } from '../commands/paymentLink/PaymentLinksApi';

export const PaymentLinksEligibilityContext =
  createContext<PaymentsEligibilityStatus>(
    PaymentsEligibilityStatus.INELIGIBLE
  );
